var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pag-reservation-bedroom"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('telas.reserva_quartos.titulo')))])]),_vm._v(" "),_c('reserva',{attrs:{"header":false,"obs":['Selecione aqui a data da sua reserva']}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eebae9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservation/SelectDates.vue
// module id = null
// module chunks = 